import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { TopHeaderService } from 'src/app/core/services/top-header/top-header.service';
import packageInfo from '../../../../../../package.json';

@Component({
  selector: 'app-header-content-footer',
  templateUrl: './header-content-footer.component.html',
  styleUrls: ['./header-content-footer.component.scss'],
})
/**
 * Header Content Footer template
 */
export class HeaderContentFooterComponent implements OnInit, OnDestroy {
  @Input() headerTitle = '';
  profilePicture = '';

  isMobile: boolean = true;
  loading: boolean = false;
  private subsink = new Subscription();

  /**
   * @constructor
   */
  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    public readonly authenticatedUserService: AuthenticatedUserService,
    public readonly topHeaderService: TopHeaderService
  ) {}

  /**
   * fetch profile picture
   */
  ngOnInit() {
    if (
      this.authenticatedUserService.representative == null ||
      this.topHeaderService.business == null ||
      this.topHeaderService.pointSummary == null
    ) {
      this.loading = true;
    }
    this.topHeaderService.fetchTopHeaderInfo().finally(() => {
      this.loading = false;
    });

    this.subsink.add(
      this.breakpointObserver
        .observe(['(min-width: 620px)'])
        .subscribe((state: BreakpointState) => {
          this.isMobile = !state.matches;
        })
    );

    console.log(`FE application version: ${packageInfo.version}`);
  }

  /**
   * clean up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
